import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import get from "lodash/get";
import {
  setHelperText,
  HolidayPlanInfo,
} from "../../../../../Actions/commonAction";

import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import SelectList from "../../../../../Component/SelectList/SelectList";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class HolidayPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isrequiremandatory: true,
      isrequireoptional: false,
      holidayyear: "",
      helperText: "",
      yearList: [],
      ErFlag: false,
      isyearselect: false,
      selectdyear: null,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("holidayplan");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.OnNext,
    });
    if (this.props.Language.holidayplan) {
      const text = this.props.Language.holidayplan.HtHolidayPreferences;
      this.props.setHelperText({ helperText: text });
    }
    this.GetYears();
    this.GetInfoFromLocalStorage();
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(2, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  GetInfoFromLocalStorage() {
    const HolidayInfo = this.props.holidayPlanReducer;

    if (!this.isEmpty(HolidayInfo)) {
      const { holidayyear } = HolidayInfo;
      const holiday = HolidayInfo.holiday ? HolidayInfo.holiday : [];
      const isrequiremandatory = HolidayInfo.isrequiremandatory != false;
      const isrequireoptional = HolidayInfo.isrequireoptional == true;
      const isyearselect = HolidayInfo.isyearselect == true;
      this.setState({
        isrequiremandatory,
        isrequireoptional,
        holidayyear,
        selectdyear: { displayname: holidayyear },
        holiday,
        isyearselect,
      });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  GetYears() {
    const yearList = [];
    const CurrentYear = new Date().getFullYear();
    const NextYear = CurrentYear + 1;
    yearList.push({ displayname: CurrentYear });
    yearList.push({ displayname: NextYear });

    this.setState({ yearList, holidayyear: yearList[0].displayname });
  }

  UpdateYear(HtField, e) {
    this.HelperSliderFlag([HtField]);

    if (e.displayname != "") {
      this.setState(
        {
          holidayyear: e.displayname,
          selectdyear: e,
          holiday: [],
          isyearselect: true,
        },
        () => {
          this.UpdateHolidayPlanInfoReducer();
        },
      );
    } else {
      this.setState(
        {
          holidayyear: e.displayname,
          selectdyear: e,
          holiday: [],
          isyearselect: false,
        },
        () => {
          this.UpdateHolidayPlanInfoReducer();
        },
      );
    }
  }

  UpdateIsRequireMandatory(HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    let ErFlag;
    if (
      this.state.isrequireoptional == false
      && selectedItem.displayvalue == false
    ) {
      ErFlag = true;
      this.props.StepError(2, true);
    } else {
      ErFlag = false;
      this.props.StepError(2, false);
    }
    this.setState(
      { isrequiremandatory: selectedItem.displayvalue, ErFlag },
      () => {
        this.UpdateHolidayPlanInfoReducer();
      },
    );
  }

  UpdateIsRequireOptional(HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    let ErFlag;
    if (
      this.state.isrequiremandatory == false
      && selectedItem.displayvalue == false
    ) {
      ErFlag = true;
      this.props.StepError(2, true);
    } else {
      ErFlag = false;
      this.props.StepError(2, false);
    }
    this.setState(
      { isrequireoptional: selectedItem.displayvalue, ErFlag },
      () => {
        this.UpdateHolidayPlanInfoReducer();
      },
    );
  }

  UpdateHolidayPlanInfoReducer() {
    const HolidayInfo = this.props.holidayPlanReducer;
    HolidayInfo.holidayyear = this.state.holidayyear;
    HolidayInfo.isrequiremandatory = this.state.isrequiremandatory;
    HolidayInfo.isrequireoptional = this.state.isrequireoptional;
    HolidayInfo.holiday = this.state.holiday;

    if (this.state.isrequireoptional == false) {
      HolidayInfo.lastdateexistingemp = null;
      HolidayInfo.isnotifyexisting = false;
      HolidayInfo.dayfornewemp = null;
      HolidayInfo.isnotifynew = false;
      HolidayInfo.maxoptlimit = null;
      HolidayInfo.isyearselect = true;
    }
    this.props.HolidayPlanInfo({ ...HolidayInfo });
  }

  OnNext = () => {
    if (this.state.ErFlag == true) {
      this.props.StepError(2, true);
    } else {
      this.props.StepError(2, false);
      this.UpdateHolidayPlanInfoReducer();
      this.props.click();
    }
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.holidayplan[${HtField}]`, "");
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;
    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    const language = this.props.Language.holidayplan;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <div className="stepper-scroller padding-top-0">
            <div className="stepper-scroller-content">
              <div className="device-wrapper opaque">
                <div className="margin-bottom-20">
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="LbForWhichYear"
                      defaultMessage="For which year are you creating these holiday preferences?"
                    />
                  </p>
                  <div className="width100">
                    <Select
                      options={this.state.yearList}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayname}
                      onChange={this.UpdateYear.bind(this, "HtHolidayYear")}
                      value={this.state.selectdyear}
                      isDisabled={
                        this.props.holidayPlanReducer.holidayplanid != null
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="device-wrapper opaque">
                <div className="form-group">
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="LbMandatoryHolidays"
                      defaultMessage="Employees get mandatory holidays"
                    />
                  </p>
                  <div className="">
                    <SelectList
                      data={options}
                      Selected={this.state.isrequiremandatory}
                      onSelected={this.UpdateIsRequireMandatory.bind(
                        this,
                        "HtIsRequireMandatory",
                      )}
                    />
                    <div>
                      {this.state.ErFlag == true ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErPleaseSelectEither"
                            defaultMessage="Please select either mandatory Or optional or both"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="device-wrapper opaque">
                <div className="form-group">
                  <p className="depedent-select-list-head">
                    <FormattedMessage
                      id="LbOptionalHolidays"
                      defaultMessage="Employees get optional holidays"
                    />
                  </p>
                  <div className="">
                    <SelectList
                      data={options}
                      Selected={this.state.isrequireoptional}
                      onSelected={this.UpdateIsRequireOptional.bind(
                        this,
                        "HtIsRequireOptional",
                      )}
                    />
                    <div>
                      {this.state.ErFlag == true ? (
                        <span className="caption-error">
                          <FormattedMessage
                            id="ErPleaseSelectEither"
                            defaultMessage="Please select either mandatory Or optional or both"
                          />
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

HolidayPreferences.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  holidayPlanReducer: state.holidayPlanReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      HolidayPlanInfo: (data) => HolidayPlanInfo(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(HolidayPreferences)));
